import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { api_url } from '../Constants/api_constant';
import { handleResponse } from '../Utils/responseHandler';
import logResponse from '../Utils/logger';
import Parser from 'html-react-parser';

const SubscriberVerificationEmail = () => {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [existcode, setExitcode] = useState('');
  const [hascode, sethasCode] = useState('');
  const [verified, setVerified] = useState('');
  const [message, setMessage] = useState('');
  const [apikey, setApikey] = useState("gd54m8auqgn7j3llo");
  const [method, setMethod] = useState("TLH");
  const [errorMessage, setErrorMessage] = useState('');

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }
  const sendVerificationEmail = () => {
    if (!isValidEmail(email)) {
      setErrorMessage('Email is invalid');
    }  else {
      setErrorMessage(null);
      fetch(api_url.API_URL + 'verification-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey' : apikey
        },
        body: JSON.stringify({ email }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          setMessage(data.data.message);
          setErrorMessage('');
          sethasCode('yes');
          if (data.data.code) {          
            setExitcode (data.data.code);
            setVerified('verified');
          }
          
        })
        .catch((error) => {
          setMessage('');
          setErrorMessage('Failed to send verification email');
        });
    }
   
  };

  const verifyEmail = () => {
    fetch(api_url.API_URL + 'verify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, code }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data.success);
        if(data.success == true) {          
          setMessage(data.data);
          setErrorMessage('');
          setVerified('verified');
        } else {
          setMessage('');
          setErrorMessage('not verified');
        }        
      })
      .catch((error) => {
        setMessage('');
        setErrorMessage('Invalid verification code');
      });
  };

  const checkEmailExistence = () => {
    fetch(api_url.API_URL + 'login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': apikey
      },
      body: JSON.stringify({ email }),
    })
    .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.Status === 'OK') {
          setMessage('Email exists <br />' + data.data.token) ;
          setErrorMessage('');         
        }  else {
          setErrorMessage(data.data);
          setMessage('');
        }
      })
      .catch((error) => {
        setMessage('');
        setErrorMessage('Failed to check email existence');
      });
  };

  return (
    <div className="container-fluid page-body-wrapper full-page-wrapper">
      <div className="content-wrapper d-flex align-items-center">
        <div className="row w-75 m-auto">
          <div className="col-lg-4 mx-auto">
            <div className="auth-form-light text-center px-sm-5"></div>
            <div className='card p-5'>
              <h6 className="font-weight-light">Login via Email.</h6>
              {
                message && <div className='alert alert-info'>{Parser(message)}</div>
              }
              {
                errorMessage && <div className='alert alert-danger'>{errorMessage}</div>
              } 
              {
              (hascode == '') ?  
              <div>        
                <div className="form-group">
                  <input
                    type="email"
                    className='form-control'
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}      />
                </div>
                <button type="submit" className='btn btn-success float-left' onClick={sendVerificationEmail}><i className='bi bi-box-arrow-in-down-right'></i> Send Verification Email</button>
              </div>
              : '' }
              {
              (hascode == 'yes' && existcode == '' && verified == '') ?
              <div>
                <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Verification Code"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                />
              </div>
              <button type="submit" className='btn btn-success float-left' onClick={verifyEmail}><i className='bi bi-box-arrow-in-down-right'></i> Verified Email</button>
              </div>
              : '' }
             <br />
               {
                (verified == 'verified') ?
                <div>
                  <div className="form-group">
                    <input type="text" className='form-control' placeholder="apikey" value={apikey} onChange={(e) => setApikey(e.target.value)} />
                    <input type="text" className='form-control' placeholder="method" value={method} onChange={(e) => setMethod(e.target.value)} />
                  </div>
                  <button type="submit" className='btn btn-success float-left' onClick={checkEmailExistence}><i className='bi bi-box-arrow-in-down-right'></i> Check Email Existence</button>

                </div>
                : '' } 
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriberVerificationEmail;
